import { render } from "./SectionPdf.vue?vue&type=template&id=88f2e60a&scoped=true"
import script from "./SectionPdf.vue?vue&type=script&lang=js"
export * from "./SectionPdf.vue?vue&type=script&lang=js"

import "./SectionPdf.vue?vue&type=style&index=0&id=88f2e60a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f2e60a"]])

export default __exports__